import { forwardRef, React, useImperativeHandle, useRef } from 'react';
import styled, { keyframes } from 'styled-components';

import LinkManagerLogoPath from '../../../image/LinkManagerLogo.png';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

const LogoView = forwardRef((props, ref) => {
	const { t } = useLanguage();
	const { isDark } = useTheme();
	const theme = isDark ? darkTheme : lightTheme;
	const TopLevelRef = useRef();

	useImperativeHandle(ref, () => ({
		setOpacity: (val) => {
			if (val === 0) {
				TopLevelRef.current.style.opacity = val;
			}
			else {
				TopLevelRef.current.style.transform = val;
			}
		}
	}))

	return (
		<TopLevelWrapper ref={TopLevelRef}>
			<BackgroundShape isDark={isDark}>
				<LogoWrapper>
					<Logo src={LinkManagerLogoPath} />
				</LogoWrapper>
				<MainName>LINKO ZONE</MainName>
				<Explanation>{t('login.slogan')}</Explanation>
			</BackgroundShape>
		</TopLevelWrapper>
	)
});

export default LogoView;

const startAnimation = keyframes`
	0% { transform: translateY(1500px); }
	100% { transform: translateY(0px); }
`;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: column;

	padding-top: max(0px, calc((100vh - 1080px) / 2));

	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const BackgroundShape = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	width: 480px;
	// width: max(210px, 25vw);
	height: calc(842px + max(0px, (100vh - 1080px) / 2));
	// height: 842px;
	// height: max(164.453125px, 43.85416666666667vw);

	margin-top: 238px;
	// margin-top: 12.39583333333333vw;
	margin-right: 132px;
	// margin-right: 6.875vw;

	border-radius: 50px 50px 0px 0px;
	box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};

	background-color: ${props => props.theme.primary};
`;

const LogoWrapper = styled.div`
	display: flex;
	flex-direction: column;

	margin-top: 87px;
	// margin-top: max(30px, 4.53125vw);
`;

const Logo = styled.img`
	width: 280px;
	// width: max(68px, 13.02083333333333vw);
	height: 280px;
	// height: max(68px, 13.02083333333333vw);

	filter: drop-shadow(10px 40px 50px #F07127);
`;

const MainName = styled.p`
	position: relative;
	z-index: 1;

	font-family: NotoSansKR-Bold;
	font-size: 50px;
	// font-size: max(13.671875px, 2.604166666666667vw);
	// line-height: 75px;
	color: ${props => props.theme.white};

	margin: 0 0 0 0;

	cursor: default;
`;

const Explanation = styled.p`
	position: relative;
	z-index: 1;

	font-family: NotoSansKR-Regular;
	font-size: 20px;
	// font-size: max(10px, 1.041666666666667vw);
	// line-height: 29px;
	color: ${props => props.theme.white};
	opacity: 0.7;

	margin: 16px 0 0 0;
	// margin-top: max(4px, 0.8333333333333333vw);
	// margin-right: 0px;
	// margin-bottom: 0px;
	// margin-left: 0px;

	cursor: default;
`;
